<template>
  <div>
    <keep-alive>
      <div class="main-contain">
        <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => (toast = val)"
        />
        <pop-up-message
          v-if="showSuccessMsgForUpdate"
          :message="`Your FBP has been successfully closed `"
          btnText="Go Back"
          @back="goBack()"
        />
        <pop-up-message
          v-if="showSuccessMsg"
          :message="`Your FBP has been successfully locked`"
          btnText="Go Back"
          @back="goBack()"
        />
        <!-- <div class="link" v-on:click="customreport">Create Custom Report</div> -->
        <div class="permission-alert-msg" v-show="!(ifAdmin || ifHr)">
          You have only view permission.
        </div>
        <div class="type" :disabled="!(ifAdmin || ifHr)">
          <date-picker
            class="datepicker"
            :initialView="'month'"
            :formatDate="'MMMM-yyyy'"
            :maximumView="'year'"
            :minimumView="'month'"
            v-model="formData"
            @datevalue="
              (val) => {
                formData = val;
                save();
              }
            "
            :dates-disabled="{
              to: new Date(leIncorporationDate),
              from: new Date(monthYear),
            }"
          />
          <tl-select
            multiple
            v-if="this.formData || this.arrayOfLocation.length > 0"
            name="location"
            id="location"
            label="Location"
            labelText="name"
            :options="locationOptions"
            v-model="arrayOfLocation"
            @change="(value) => subType(value)"
          />

          <tl-checkbox v-if="this.formData || this.arrayOfLocation.length > 0" :checked="locationCheckbox" label="All Locations" @change="(val)=>{locklist(val)}"></tl-checkbox>

        </div>
        <div class="lock-list">
          <tl-checkbox
            v-if="this.locationType || this.checkBoxSelect"
            class="checkbox"
            label="Process Lock"
            :checked="checkBoxSetting.processBox"
            @change="(val) => (checkBoxSetting.processBox = val)"
          ></tl-checkbox>
          <tl-checkbox
            v-if="this.checkBoxSelect"
            class="checkboxClose"
            label="Close"
            :checked="checkBoxSetting.closeBox"
            @change="(val) => (checkBoxSetting.closeBox = val)"
          ></tl-checkbox>
        </div>
        <footer>
          <bottom-action-container>
            <template slot="end">
              <btn-grp>
                <btn
                  :disabled="!this.checkBoxSetting.closeBox"
                  v-if="this.checkBoxSelect"
                  text="update"
                  type="primary"
                  v-on:click="update"
                ></btn>
                <btn
                  :disabled="!this.checkBoxSetting.processBox"
                  v-if="!this.checkBoxSelect"
                  text="save"
                  type="primary"
                  v-on:click="submit"
                ></btn>
              </btn-grp>
            </template>
          </bottom-action-container>
        </footer>
      </div>
    </keep-alive>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      month: new Date(),
      monthOptions: [],
      leIncorporationDate: null,
      locationType: "",
      checkBoxSelect: "",
      formData: "",
      errmsg:null,
      navItems: [],
      toast: false,
      locationId: [],
      arrayOfLocation: [],
      locationArray: [],
      showSuccessMsg: false,
      showSuccessMsgForUpdate: false,
      editMode: false,
      locationOptions: [],
      locationCheckbox: false,
      checkBoxSetting: {
        processBox: false,
        closeBox: false,
      },
      isLockingExits: false,
      monthYear:'',
      monthIndex: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec"
      ],
    };
  },
  mounted() {
    this.getLocations();
    this.getFbpLockDate();
  },
  activated() {
    this.getLocations();
  },

  computed: {
    ...mapState({
      locations: (state) => state.onboard.locations.data,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),

    ...mapState("dashboard/humanResource/lockFBP", {
      FBPSlabsDataAll: (state) => state.entityWiseData,
      isFetching: (state) => state.isFetching,
      isSaving: (state) => state.isSaving,
      isDeleting: (state) => state.isDeleting,
    }),
    ...mapGetters({
      getLeId: "onboard/legal_entities/legal_entity_ID",
    }),
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifAdmin() {
      return localStorage.getItem("userRole") == "ADMIN" ? true : false;
    },
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLeId(this.$route.params.entity_index);
      } else {
        return this.getLeId(0);
      }
    },
  },

  methods: {
    ...mapActions({
      act_fetch_locations: "onboard/locations/fetchAll",
    }),
    ...mapActions({
      act_create: "dashboard/humanResource/lockFBP/create",
      act_fetch: "dashboard/humanResource/lockFBP/fetchAll",
      act_update: "dashboard/humanResource/lockFBP/update",
    }),
    /* function to refresh the page */
    refresh() {
      try {
        this.locationOptions=[]
        this.errmsg = "";
        this.toast = false;
        (this.arrayOfLocation = []), (this.formData = "");
        this.checkBoxSetting = {
          processBox: false,
          closeBox: false,
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    goBack() {
      this.refresh();
      this.checkBoxSelect = false;
      this.locationType = "";
      this.showSuccessMsg = false;
      this.showSuccessMsgForUpdate = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbpLock`,
      });
    },

    getFbpLockDate(){
      let index = this.monthIndex.findIndex(item => item === this.payrollMonth.toLowerCase().slice(0, 3));
      let lastday = new Date(this.payrollYear, index + 1, 0);

      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      let formattedDate = new Intl.DateTimeFormat('en-US', options).format(lastday);

      this.monthYear = formattedDate;
    },

    subType(val) {
      //console.log(val);
      this.locationType = val;
      this.arrayOfLocation = val;
      if(this.locationType.length == 0 || this.locationType.length < this.locationOptions.length){
        this.locationCheckbox = false;
      }
      //console.log(this.arrayOfLocation);
    },

    locklist(value){
      if(value == true){
        this.locationCheckbox = true;
        this.locationType = this.locationOptions;
        this.arrayOfLocation = this.locationOptions;
      }else{
        this.locationCheckbox = false;
        this.locationType = null;
        this.arrayOfLocation = null;
      }
    },
    /* server call to get locations */
    async getLocations() {
      try {
        let res = await this.act_fetch_locations(this.leId);
        //console.log(res.data);
        this.locationOptions = res.data.payload.data;
        //console.log(this.locationOptions);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    update() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.actionForUpdate();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.performingAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          //console.log("i am called line no 276");
          this.checkBoxSetting.processBox = false;
          this.checkBoxSelect = false;
          this.arrayOfLocation = [];
          this.fetchAllFbpLockDetails();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },
    /* server call to   update FBPLOCK */
    async actionForUpdate() {
      try {
        //console.log("eneterd to if updation action", this.arrayOfLocation);
        const instancess = this.formData.split("-");
        let selectedMonth;
        if (instancess[1] == "01") {
          selectedMonth = "January";
        } else if (instancess[1] == "02") {
          selectedMonth = "February";
        } else if (instancess[1] == "03") {
          selectedMonth = "March";
        } else if (instancess[1] == "04") {
          selectedMonth = "April";
        } else if (instancess[1] == "05") {
          selectedMonth = "May";
        } else if (instancess[1] == "06") {
          selectedMonth = "June";
        } else if (instancess[1] == "07") {
          selectedMonth = "July";
        } else if (instancess[1] == "08") {
          selectedMonth = "August";
        } else if (instancess[1] == "09") {
          selectedMonth = "September";
        } else if (instancess[1] == "10") {
          selectedMonth = "October";
        } else if (instancess[1] == "11") {
          selectedMonth = "November";
        } else if (instancess[1] == "12") {
          selectedMonth = "December";
        } else {
          //console.log(instancess[1]);
        }
     
        //console.log(this.formData);
        let res = await this.act_update({
          locations: this.arrayOfLocation
            ? this.arrayOfLocation.map((item) => {
                return item.id;
              })
            : [],
          year: instancess[0],
          month: selectedMonth.toLowerCase().slice(0,3),
          le_id: this.leId,
          process_lock: this.checkBoxSetting.processBox,
          close: this.checkBoxSetting.closeBox,
        });
        if (res.status == 200) {
          this.showSuccessMsgForUpdate = true;
          //console.log(this.showSuccessMsgForUpdate);
        } else {
          //console.log(res);
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* server call to create FBP LOCK */
    async performingAction() {
      try {
        const instance = this.formData.split("-");
        let selectedMonth;

        if (instance[1] == "01") {
          selectedMonth = "January";
        } else if (instance[1] == "02") {
          selectedMonth = "February";
        } else if (instance[1] == "03") {
          selectedMonth = "March";
        } else if (instance[1] == "04") {
          selectedMonth = "April";
        } else if (instance[1] == "05") {
          selectedMonth = "May";
        } else if (instance[1] == "06") {
          selectedMonth = "June";
        } else if (instance[1] == "07") {
          selectedMonth = "July";
        } else if (instance[1] == "08") {
          selectedMonth = "August";
        } else if (instance[1] == "09") {
          selectedMonth = "September";
        } else if (instance[1] == "10") {
          selectedMonth = "October";
        } else if (instance[1] == "11") {
          selectedMonth = "November";
        } else if (instance[1] == "12") {
          selectedMonth = "December";
        } else {
          //console.log(instance[1]);
        }
        //console.log(selectedMonth);
        //console.log(this.formData);
        let res = await this.act_create({
          locations: this.arrayOfLocation
            ? this.arrayOfLocation.map((item) => {
                return item.id;
              })
            : [],
          year: instance[0],
          month: selectedMonth.toLowerCase().slice(0,3),
          le_id: this.leId,
          process_lock: this.checkBoxSetting.processBox,
          close: this.checkBoxSetting.closeBox,
        });
        this.showSuccessMsg = true;
        //console.log(this.showSuccessMsgForUpdate);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get FBPLOCK DETAILS */
    async fetchAllFbpLockDetails() {
      try {
        this.locationType = "";
        const instance = this.formData.split("-");
        let selectedMonth;
        if (instance[1] == "01") {
          selectedMonth = "January";
        } else if (instance[1] == "02") {
          selectedMonth = "February";
        } else if (instance[1] == "03") {
          selectedMonth = "March";
        } else if (instance[1] == "04") {
          selectedMonth = "April";
        } else if (instance[1] == "05") {
          selectedMonth = "May";
        } else if (instance[1] == "06") {
          selectedMonth = "June";
        } else if (instance[1] == "07") {
          selectedMonth = "July";
        } else if (instance[1] == "08") {
          selectedMonth = "August";
        } else if (instance[1] == "09") {
          selectedMonth = "September";
        } else if (instance[1] == "10") {
          selectedMonth = "October";
        } else if (instance[1] == "11") {
          selectedMonth = "November";
        } else if (instance[1] == "12") {
          selectedMonth = "December";
        } else {
          //console.log(instance[1]);
        }
        //console.log(selectedMonth);
        //console.log(this.formData);
        let le_id = this.leId;
        let month = selectedMonth.toLowerCase().slice(0,3);
        let year = instance[0].toString();
        let res = await this.act_fetch({ le_id, month, year });
        if (res.data.payload.data.length > 0) {
          this.locationId = res.data.payload.data[0].locations;
          this.arrayOfLocation = [];
          for (let i = 0; i <= this.locationId.length; i++) {
            this.locationOptions.map((items) => {
              if (items.id == this.locationId[i]) {
                this.arrayOfLocation.push(items);
              } else {
                //console.log("");
              }
            });
          }
          this.checkBoxSetting.processBox =
            res.data.payload.data[0].process_lock;
          this.checkBoxSelect = true;
        }
        if(res.data.payload.data[0] && res.data.payload.data[0].locations.length == this.locationOptions.length){
          this.locationCheckbox = true;
        }
      } catch (error) {
        //console.log(error);
        this.toast = true;
        this.errmsg = error;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  margin-top: 37px;
}
.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}
.lock-list {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
}
.checkbox {
  margin-top: -15px;
}
.checkboxClose{
  margin-top: 35px;
}
.formbutton {
  color: blue;
}
.type {
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  div {
    width: 250px;
    padding-right: 20px;
    margin-top: 15px;
  }
}
</style>
